// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CombinationChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import cfgFactories from 'share/factories/Izenda.ReportPartStyleConfigurationFactories';
import localizer from 'share/localization/Izenda.Localizer';
import CombinationChartOptionsBuilder from './Izenda.CombinationChartOptionsBuilder';

import { REPORT_PART_TYPE } from 'logic/data/Izenda.ReportDesignerConstants';
import { createXAxisSchema, createYAxisMetricsSchema } from '../FieldContainers/Izenda.FieldContainerSchemaFunctions';
import { MappingValues, CHART_TYPE } from 'logic/data/Izenda.ChartDefaultConfig';
import VISUAL_TYPE from 'share/components/charting/highcharts/Izenda.VisualTypeMapping';

const { STACK_TYPE_CHART_VALUES, STEP_TYPE_VALUES, ZOOM_TYPE_VALUES, LINE_STYLE_VALUES } = MappingValues;

cfgFactories.extendConfiguration(REPORT_PART_TYPE.Chart, CHART_TYPE.Combination, null, {
  visualType: VISUAL_TYPE.Combination,

  get visualLabel() {
    return localizer.getText('REPORT_CHART_TYPE_COMBINATION');
  },

  visualPreviewCSS: 'chart-combo',

  optionsBuilder: CombinationChartOptionsBuilder,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [createXAxisSchema(), createYAxisMetricsSchema],

  optionsMapping: {
    optionsByType: {
      chartType: { propKey: 'type', propSource: VISUAL_TYPE, defaultValue: undefined },
      izLineDashStyle: { propKey: 'dashStyle', propSource: LINE_STYLE_VALUES, defaultValue: undefined },
      izLineWidth: { propKey: 'lineWidth', defaultValue: undefined },
      izMultiColor: { propKey: 'plotOptions.series.colorByPoint', defaultValue: false },

      /* options for all line-series */
      izXYplane: { defaultValue: undefined },
      izGridline: { defaultValue: undefined },

      izLabelOrientation: { defaultValue: undefined },
      izLabelOrientationX: { defaultValue: undefined },
      izLabelOrientationY: { defaultValue: undefined },

      izStacking: { propKey: 'plotOptions.series.stacking', propSource: STACK_TYPE_CHART_VALUES },
      izThresholds: { defaultValue: undefined },
      izRegressionLine: { defaultValue: undefined },

      izInverted: { propKey: 'chart.inverted', defaultValue: false },

      izValueLabel: { propKey: 'plotOptions.series.dataLabels.enabled', defaultValue: false },
      izZoom: { propKey: 'chart.zoomType', propSource: ZOOM_TYPE_VALUES, defaultValue: undefined },

      legendSettings: { defaultValue: true },

      izStep: { propKey: 'plotOptions.series.step', propSource: STEP_TYPE_VALUES, defaultValue: undefined },
      izSpline: { propKey: 'izendaOptions.spline', defaultValue: undefined },
      izSingleYAxis: { defaultValue: false }
    }
  }
});



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartChart/Izenda.CombinationChartConfiguration.js